module.exports = __webpack_public_path__ + "img/72ne.ca279b18.svg";